import { Lock } from 'lucide-react';

export function UnauthorizedPage() {
  return (
    <div className="flex items-center justify-center p-8">
      <div className="flex flex-col items-center gap-3 bg-bg-elevated border border-border-default rounded-lg shadow-sm p-8 max-w-sm">
        <Lock className="w-8 h-8 text-text-muted" />
        <p className="text-lg font-semibold text-text-primary">Access Denied</p>
        <p className="text-sm text-text-secondary text-center">
          You are not authorized to access this page. Please contact your operator if you believe this is an error.
        </p>
      </div>
    </div>
  );
}
